export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submit: "auth-submit-button",
  toggle: "auth-toggle-mode",
  logout: "logout-button",
};

export const NAV = {
  sidebar: "app-sidebar",
  learners: "nav-learners",
  cards: "nav-cards",
  trials: "nav-trials",
};

export const LEARNERS = {
  addBtn: "add-learner-button",
  nameInput: "learner-name-input",
  ageInput: "learner-age-input",
  diagnosisInput: "learner-diagnosis-input",
  notesInput: "learner-notes-input",
  saveBtn: "learner-save-button",
  card: (id) => `learner-card-${id}`,
  openBtn: (id) => `learner-open-${id}`,
  deleteBtn: (id) => `learner-delete-${id}`,
};

export const CARDS = {
  addBtn: "add-card-button",
  labelInput: "card-label-input",
  operantSelect: "card-operant-select",
  fileInput: "card-file-input",
  urlInput: "card-url-input",
  saveBtn: "card-save-button",
  card: (id) => `stimulus-card-${id}`,
  deleteBtn: (id) => `card-delete-${id}`,
  assignBtn: (id) => `card-assign-${id}`,
};

export const TRIAL = {
  learnerSelect: "trial-learner-select",
  arraySize: "trial-array-size",
  operantFilter: "trial-operant-filter",
  statusFilter: "trial-status-filter",
  start: "trial-start-button",
  reshuffle: "trial-reshuffle-button",
  exit: "trial-exit-button",
  presented: (i) => `trial-card-${i}`,
};
